import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { CreateBoxErrorsMapper, CreateBoxMapper } from '../mappers';
import { CreateBoxDto } from '../dtos';

export type ICreateBoxRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type ICreateBoxRepo = IRepo<[CreateBoxDto, string | number | undefined], ICreateBoxRepoResponse>;

export const CreateBoxRepoType = Symbol.for('CreateBoxRepo');

@bind(CreateBoxRepoType)
export class CreateBoxRepo implements ICreateBoxRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: CreateBoxDto, id?: string | number) {
    try {
      const body = new FormData();
      const mappedBody = CreateBoxMapper.toPersistence(dto);

      appendToFormData(mappedBody, body);

      const url = id ? urlMaker('/api/admin/containers/edit') : urlMaker('/api/admin/containers/create');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        const errors = CreateBoxErrorsMapper.toDomain(result.data.errors);

        return {
          status: 422 as 422,
          response: errors,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
